import baseRoute from '../baseRoute';

export default `${baseRoute}/organizationCredential` as const;
